import { useNavigate, Link } from 'react-router-dom';
import { getPrimaryImage } from '../../services/imageService';
import Image from '../common/Image';
import './NewArrivalsSection.css';

const NewArrivalsSection = ({ products = [] }) => {
    const navigate = useNavigate();

    const handleProductClick = slug => {
        navigate(`/products/${slug}`);
    };

    // Use actual products from API, limit to 4
    const displayProducts = products && products.length > 0 ? products.slice(0, 4) : [];

    // Don't render section if no products available
    if (displayProducts.length === 0) {
        return null;
    }

    // Background colors for cards (alternating black/white)
    const getBackgroundColor = (index) => {
        return index % 2 === 0 ? '#000000' : '#ffffff';
    };

    return (
        <section className="new-arrivals-section">
            <div className="new-arrivals-container">
                <div className="new-arrivals-header" data-reveal-item>
                    <h2 className="new-arrivals-title">New Arrivals</h2>
                    <Link to="/products?sortBy=created_at&sortOrder=DESC" className="see-all-link">See All</Link>
                </div>

                <div className="new-arrivals-grid">
                    {displayProducts.map((product, index) => {
                        const primaryImage = getPrimaryImage(product.images);

                        return (
                            <div
                                key={product.id}
                                className="new-arrivals-card"
                                onClick={() => handleProductClick(product.slug)}
                                data-reveal-item
                                style={{ '--reveal-index': index + 1 }}
                            >
                                <div
                                    className="new-arrivals-image-wrapper"
                                    style={{ backgroundColor: getBackgroundColor(index) }}
                                >
                                    <Image
                                        src={primaryImage?.image_url}
                                        alt={product.name}
                                        className="new-arrivals-image"
                                        fallback="/placeholder-watch.jpg"
                                    />
                                </div>
                                <h3 className="new-arrivals-product-name">
                                    {product.name}
                                </h3>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default NewArrivalsSection;
